type DivProps = JSX.IntrinsicElements['div'];
export const ListItem = (props: DivProps) => <div role="listitem" {...props} />;
